'use strict';

var renameField = require('./rename-field');
var makeObject = require('./make-object');
var mergeObjects = require('./merge-objects');
var summary = require('./summary');

var decoders = [renameField('K', 'keywords'), renameField('WH', 'where'), renameField('WID', 'whereid'), renameField('I', 'classification'), renameField('O', 'subclassification'), renameField('SORT', 'sortmode'), renameField('D', 'daterange'), renameField('W', 'worktype'), renameField('N', 'page'), renameField('CID', 'companyid'), renameField('NA', 'nation'), renameField('L', 'location'), renameField('A', 'area'), renameField('ADV', 'advertiserid'), renameField('ADG', 'advertisergroup'), function decodeSalaryType(cookie) {
  var value = cookie.SL;

  if (!value) {
    return {};
  }

  return { salarytype: value.toLowerCase() };
}, function decodeSalaryRange(cookie) {
  if (!(cookie.SF || cookie.ST)) {
    return {};
  }

  return { salaryrange: cookie.SF + '-' + cookie.ST };
}, function decodeGraduateSearch(cookie) {
  return cookie.C ? { graduatesearch: 'true' } : {};
}];

var deserialiseCookie = function deserialiseCookie(cookie) {
  var cookieParts = cookie.split('~').map(function (encoded) {
    var parts = encoded.split('|');
    var key = parts[0];
    var value = parts.slice(1).join('|');

    return makeObject(key, value);
  });

  return mergeObjects(cookieParts);
};

var parseTimestamp = function parseTimestamp(cookie) {
  var timestamp = cookie.OSF && cookie.OSF.split('=')[1];

  return timestamp && /^\d+$/.test(timestamp) ? parseInt(timestamp, 10) : null;
};

module.exports = function (cookie, locale) {
  if (!cookie) {
    return null;
  }

  var deserialisedCookie = deserialiseCookie(decodeURIComponent(cookie));
  var decodedParts = decoders.map(function (decode) {
    return decode(deserialisedCookie);
  });

  var query = mergeObjects(decodedParts);
  var timestamp = parseTimestamp(deserialisedCookie);

  if (!timestamp) {
    return null;
  }

  return {
    query: query,
    date: new Date(timestamp),
    summary: summary(query, locale)
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/decode.js
 ** module id = 461
 ** module chunks = 0
 **/